var Container = /** @class */ (function () {
    function Container() {
        this._services = {};
    }
    Container.register = function (service) {
        this.instance._services[service.name] = new service();
    };
    Container.get = function (service) {
        var instance = this.instance._services[service.name];
        if (!instance) {
            throw Error('Service not found');
        }
        return instance;
    };
    Container.instance = new Container();
    return Container;
}());
export { Container };
//# sourceMappingURL=container.js.map